










































































































































import SfMegaMenu from '/storefrontUI/components/components/organisms/SfMegaMenu/SfMegaMenu.vue';
import SfProductCard from '/storefrontUI/components/components/organisms/SfProductCard/SfProductCard.vue';
import SfScrollable from '/storefrontUI/components/components/molecules/SfScrollable/SfScrollable.vue';
import SfMenuItem from '/storefrontUI/components/components/molecules/SfMenuItem/SfMenuItem.vue';
import SfButton from '/storefrontUI/components/components/atoms/SfButton/SfButton.vue';
import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import {  useRouter, useContext } from '@nuxtjs/composition-api';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import { useImage, useProduct } from '~/composables';
import SvgImage from '~/components/General/SvgImage.vue';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'SearchResults',
  components: {
    SfMegaMenu,
    SfProductCard,
    SfScrollable,
    SfMenuItem,
    SfButton,
    SvgImage,
  },
  props: {
    term: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    searchResults: {
      type: Array as PropType<Product[] | null>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const { app } = useContext();
    const { getMagentoImage, imageSizes } = useImage();
    const { getProductPath } = useProduct();

    const handleSearchClick = async () => {
      await router.push(`${app.localePath('/ricerca/?term='+props.term)}`);
    };

    return {
      productGetters,
      getMagentoImage,
      imageSizes,
      getProductPath,
      handleSearchClick,
    };
  },
});
